/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_health_profile_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to remember your details across all health tools`)
};

const es_health_profile_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para recordar tus datos en todas las herramientas de salud`)
};

const de_health_profile_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melde dich an, damit alle Gesundheits-Tools deine Angaben merken`)
};

const nl_health_profile_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meld je aan om je gegevens in alle gezondheidstools te onthouden`)
};

const fr_health_profile_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous pour mémoriser vos informations dans tous les outils santé`)
};

const it_health_profile_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi per ricordare i tuoi dati in tutti gli strumenti salute`)
};

const pt_br2_health_profile_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre para lembrar seus dados em todas as ferramentas de saúde`)
};

const pt_health_profile_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sessão para lembrar os teus dados em todas as ferramentas de saúde`)
};

const ja_health_profile_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインすると、すべての健康ツールであなたの情報を記憶します`)
};

const zh_health_profile_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后，所有健康工具都会记住你的信息`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const health_profile_signin_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.health_profile_signin_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("health_profile_signin_hint", locale)
	if (locale === "en") return en_health_profile_signin_hint(inputs)
	if (locale === "es") return es_health_profile_signin_hint(inputs)
	if (locale === "de") return de_health_profile_signin_hint(inputs)
	if (locale === "nl") return nl_health_profile_signin_hint(inputs)
	if (locale === "fr") return fr_health_profile_signin_hint(inputs)
	if (locale === "it") return it_health_profile_signin_hint(inputs)
	if (locale === "pt-BR") return pt_br2_health_profile_signin_hint(inputs)
	if (locale === "pt") return pt_health_profile_signin_hint(inputs)
	if (locale === "ja") return ja_health_profile_signin_hint(inputs)
	return zh_health_profile_signin_hint(inputs)
};